import {
    SET_TOPICS_QUESTIONS_TREND
} from "../../../constants";


export const setTopoicsAndQuestions = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: SET_TOPICS_QUESTIONS_TREND, payload });
    }
};